import Footer from 'components/Footer'
import RootWrapper from 'pages/utils/RootWrapper'
import React from 'react'
import styled from 'styled-components'
import HyperCatCrying from './hypercat-crying.png'
import { ButtonPrimary } from 'components/Button'
import { LINKS } from 'constants/links'
import { Helmet } from 'react-helmet'

const MaintenanceWrapper = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  position: relative;
  padding: 16px;
`

const MaintenanceNote = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    font-family: 'unbounded';
  }

  p {
    font-size: 14px;
    text-align: center;
    color: ${({ theme }) => theme.text2};
    margin-bottom: 24px;
  }
  button {
    max-width: 200px;
  }
`

const MaintenancePage = () => {
  return (
    <>
      <Helmet>
        <title>Maintenance | HyperSwap Exchange on Hyperliquid</title>
        <meta
          name="description"
          content="HyperSwap Exchange is currently undergoing maintenance. We will be back online shortly to provide you with the best decentralized exchange experience."
        />
        <meta
          name="keywords"
          content="HyperSwap maintenance, DEX maintenance, platform update, crypto exchange downtime, Hyperliquid EVM"
        />
        <meta property="og:title" content="Maintenance | HyperSwap Exchange on Hyperliquid" />
        <meta
          property="og:description"
          content="HyperSwap Exchange is temporarily under maintenance. Thank you for your patience as we improve your experience."
        />
        <meta property="og:url" content={`${window.location.origin}`} />
      </Helmet>
      <RootWrapper>
        <MaintenanceWrapper>
          <MaintenanceNote>
            <img src={HyperCatCrying} alt="loading failed" style={{ width: '200px', borderRadius: '10000px' }} />
            <h1 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px' }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#4afc38"
                strokeWidth="2"
                className="icon icon-tabler icons-tabler-outline icon-tabler-alert-triangle"
                style={{ verticalAlign: 'middle', marginRight: '6px' }}
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M12 9v4" />
                <path d="M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z" />
                <path d="M12 16h.01" />
              </svg>
              Maintenance Notice
            </h1>
            <p>
              We apologize for the inconvenience. HyperSwap Exchange is currently under maintenance. <br />
              <br />
              We’ll update you as soon as it’s back up. Thank you for your patience!
              <br /> <br />
              In the meantime, join our Discord for updates and to connect with the community.
            </p>

            <ButtonPrimary onClick={() => window.open(LINKS.discord.link, '_blank')}>Join Discord</ButtonPrimary>
          </MaintenanceNote>
        </MaintenanceWrapper>
      </RootWrapper>
      <Footer />
    </>
  )
}
export default MaintenancePage
